<template>
  <div>
    <div class="root-layout">
      <div class="root-layout__header">
        <TheHeader />
      </div>

      <div class="root-layout__body">
        <slot />
      </div>

      <template v-if="isVisibleReviewsBlock">
        <div
          v-if="!isReviewsNear"
          ref="refReviewsSentinel"
          style="height: 1px"
        />
        <ReviewsBlock
          v-if="isReviewsNear"
          cfgs="{}"
          extras="{}"
          :values="{heading: 'Отзывы'}"
        />
      </template>

      <div
        class="root-layout__footer"
        :class="classFooter"
      >
        <Footer />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TheHeader from '~/components/layout/Header.vue';
import Footer from '~/components/layout/Footer.vue';
import type { ComputedRef } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import { appConfigStore as useAppConfigStore } from '#sitis/stores/modules/app-store';

const appConfigStore = useAppConfigStore();
const ReviewsBlock = defineAsyncComponent(() => import('~/cms/blocks/ReviewsBlock.vue'));
const isVisibleReviewsBlock: ComputedRef<boolean> = computed(() => {
  const { path, name } = useRoute();
  if (['/', '/contact-us'].includes(path)) {
    return false
  }
  if (['3d-projects', '3d-projects-slug', 'catalog-slug', 'sets-slug', 'akcii-slug'].includes(String(name))) {
    return false
  }
  return true
});

// Отзывы ниже фолда на длинных страницах (коллекция), а defineAsyncComponent резолвит
// весь граф модулей ReviewsBlock (ReviewCard, MobileSwiper, ...) при гидратации — таск
// ~600мс, блокирующий тапы (INP). Монтируем блок только когда сентинел входит во вьюпорт.
// rootMargin оставлен нулевым: при чанковке карточек страница в первые секунды короткая,
// сентинел лежит в ~950px от верха, и положительный margin заставил бы его сработать рано.
const refReviewsSentinel = ref<HTMLElement | null>(null);
const isReviewsNear = ref(false);
useIntersectionObserver(
  refReviewsSentinel,
  ([{ isIntersecting }]) => {
    if (isIntersecting) {
      isReviewsNear.value = true;
    }
  },
  { threshold: 0 }
);

const classFooter: ComputedRef<string> = computed(() => {
  const { path } = useRoute();

  let _list: string[] = [];
  if (['/', '/kak-sdelat-zakaz', '/articles'].includes(path)) {
    _list.push('mt-0')
  }

  return _list.join(' ')
});
</script>

<style lang="scss" scoped>
</style>
